// ADC-IMPLEMENTS: <adc-006a-feature-sidebar-01>
import { ShieldAlert } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { SidebarMenuButton } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import { type IncidentSummary } from '@/lib/incidentUtils';

interface SidebarIncidentSummaryProps {
  summary: IncidentSummary;
}

export function SidebarIncidentSummary({ summary }: SidebarIncidentSummaryProps) {
  const location = useLocation();
  const activeCount = summary.total;

  const badgeClass = summary.bySeverity.critical > 0
    ? 'bg-red-600 text-white'
    : summary.bySeverity.high > 0
    ? 'bg-red-500 text-white'
    : summary.bySeverity.medium > 0
    ? 'bg-yellow-500 text-black'
    : 'bg-blue-500 text-white';

  return (
    <SidebarMenuButton asChild isActive={location.pathname.startsWith('/incidents')} tooltip="Incidents">
      <Link to="/incidents" className="flex items-center">
        <ShieldAlert className="mr-3 h-4 w-4" />
        <span>Incidents</span>
        {activeCount > 0 && (
          <Badge className={cn("ml-auto text-xs", badgeClass)}>
            {activeCount}
          </Badge>
        )}
      </Link>
    </SidebarMenuButton>
  );
}
